var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCsv01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#404040;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1293",
    className: "st0",
    d: "M6.9,35.5h22.2c1.6,0,2.9-1.3,2.9-2.9V8.1c0-0.2-0.1-0.3-0.2-0.4l-7-7 c-0.1-0.1-0.3-0.2-0.4-0.2H6.9C5.3,0.5,4,1.8,4,3.4v29.2C4,34.2,5.3,35.5,6.9,35.5z M25,2.5l5,5h-3.3c-1,0-1.8-0.8-1.8-1.8V2.5z  M5.2,3.4c0-1,0.8-1.8,1.8-1.8h16.9v4.1c0,1.6,1.3,2.9,2.9,2.9h4.1v23.9c0,1-0.8,1.8-1.8,1.8H6.9c-1,0-1.8-0.8-1.8-1.8L5.2,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1305",
    className: "st0",
    d: "M8.1,8.7h7c0.3,0,0.6-0.2,0.6-0.6c0-0.3-0.2-0.6-0.6-0.6c0,0,0,0,0,0h-7 c-0.3,0-0.6,0.3-0.6,0.6C7.5,8.4,7.8,8.6,8.1,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1298",
    className: "st0",
    d: "M8.1,12.2h3.5c0.3,0,0.6-0.2,0.6-0.6c0-0.3-0.2-0.6-0.6-0.6c0,0,0,0,0,0H8.1 c-0.3,0-0.6,0.3-0.6,0.6C7.5,11.9,7.8,12.2,8.1,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1294",
    className: "st0",
    d: "M13.3,11.6c0,0.3,0.3,0.6,0.6,0.6h14c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-14 C13.6,11,13.3,11.3,13.3,11.6C13.3,11.6,13.3,11.6,13.3,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1295",
    className: "st0",
    d: "M8.1,15.7h11.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H8.1c-0.3,0-0.6,0.3-0.6,0.6 C7.5,15.4,7.8,15.7,8.1,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1299",
    className: "st0",
    d: "M27.9,14.5h-5.8c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h5.8c0.3,0,0.6-0.3,0.6-0.6 C28.5,14.8,28.2,14.5,27.9,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1300",
    className: "st0",
    d: "M8.1,19.2h7c0.3,0,0.6-0.3,0.6-0.6S15.4,18,15.1,18h-7c-0.3,0-0.6,0.3-0.6,0.6 S7.7,19.2,8.1,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1296",
    className: "st0",
    d: "M27.9,18H17.4c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6l0,0h10.5c0.3,0,0.6-0.3,0.6-0.6 S28.3,18,27.9,18L27.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1297",
    className: "st0",
    d: "M8.1,22.7h14c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-14c-0.3,0-0.6,0.3-0.6,0.6 C7.5,22.4,7.7,22.7,8.1,22.7L8.1,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1301",
    className: "st0",
    d: "M27.9,21.5h-3.5c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h3.5c0.3,0,0.6-0.3,0.6-0.6 C28.5,21.8,28.3,21.5,27.9,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1304",
    className: "st0",
    d: "M8.1,26.2h4.7c0.3,0,0.6-0.3,0.6-0.6S13.1,25,12.7,25H8.1c-0.3,0-0.6,0.3-0.6,0.6 S7.7,26.2,8.1,26.2L8.1,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1306",
    className: "st0",
    d: "M21.5,25.6c0-0.3-0.3-0.6-0.6-0.6c0,0,0,0,0,0h-5.8c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 h5.8C21.2,26.2,21.5,25.9,21.5,25.6C21.5,25.6,21.5,25.6,21.5,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1307",
    className: "st0",
    d: "M27.9,25h-4.7c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h4.7c0.3,0,0.6-0.3,0.6-0.6 S28.3,25,27.9,25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1303",
    className: "st0",
    d: "M8.1,29.7h7c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6h-7c-0.3,0-0.6,0.3-0.6,0.6 S7.7,29.7,8.1,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1302",
    className: "st0",
    d: "M23.3,28.5h-5.8c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6l0,0h5.8c0.3,0,0.6-0.3,0.6-0.6 S23.6,28.5,23.3,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1308",
    className: "st0",
    d: "M27.9,28.5h-2.3c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h2.3c0.3,0,0.6-0.3,0.6-0.6 S28.3,28.5,27.9,28.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCsv01);
export default __webpack_public_path__ + "static/media/ico-csv-01.8626d1f800ffa09697239ebe1f292807.svg";
export { ForwardRef as ReactComponent };